export var FilebeatConfWizSubjects;
(function (FilebeatConfWizSubjects) {
    FilebeatConfWizSubjects["AddField"] = "add-field";
    FilebeatConfWizSubjects["RemoveField"] = "remove-field";
    FilebeatConfWizSubjects["RemoveLogTypeSection"] = "remove-log-type-section";
    FilebeatConfWizSubjects["Multiline"] = "multiline";
    FilebeatConfWizSubjects["PopoverError"] = "popover-error";
    FilebeatConfWizSubjects["AddLogType"] = "add-log-type";
    FilebeatConfWizSubjects["FilebeatConfWiz"] = "filebeat-conf-wiz";
})(FilebeatConfWizSubjects || (FilebeatConfWizSubjects = {}));
//# sourceMappingURL=filebeat-conf-wiz.enum.js.map